import { useEffect, useState } from 'react';
import { getGeoConfig, getGeoSettings, unwrapGeoPayload } from '../../../api';

/** Loads Prompt Pulse config and run settings from the MI API. */
export default function useGeoBootstrap() {
  const [config, setConfig] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const [configRes, settingsRes] = await Promise.all([
          getGeoConfig(),
          getGeoSettings(),
        ]);
        if (cancelled) return;
        setConfig(unwrapGeoPayload(configRes) || null);
        setSettings(unwrapGeoPayload(settingsRes) || null);
      } catch (err) {
        if (!cancelled) {
          console.error('Error loading GEO bootstrap:', err);
          setError(err?.message || 'Failed to load Prompt Pulse config');
          setConfig(null);
          setSettings(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  return { config, settings, loading, error };
}
